var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocumentsFileCopy = function SvgDocumentsFileCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 20.403v-8.54c0-.425-.168-.833-.469-1.133l-2.263-2.263c-.3-.3-.707-.469-1.132-.469h-5.54a1.6 1.6 0 0 0-1.6 1.6v10.805a1.6 1.6 0 0 0 1.6 1.6H14.4a1.6 1.6 0 0 0 1.6-1.6Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.002h3.402a1.6 1.6 0 0 0 1.6-1.6V7.86c0-.425-.168-.832-.469-1.133L18.27 4.466c-.3-.3-.707-.47-1.132-.47h-5.54a1.6 1.6 0 0 0-1.6 1.601v2.401",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.002 7.998H17.8a.8.8 0 0 1-.8-.8V3.996M16 12h-3.202a.8.8 0 0 1-.8-.8V7.997",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDocumentsFileCopy;